export const number = (value: number): number | string => (typeof value === 'number' ? value.toLocaleString() : value);

export const random = (minimum = 0, maximum = 10): number => Math.round(Math.random() * (maximum - minimum) + minimum);
